import axios from 'axios';

const Service = {
  getCoinsByIds: async (id) => {
    const url = `https://api.coinranking.com/v1/public/coins?base=GBP&ids=${id}`;

    const request = await axios.get(url)
      .then(response => response.data)
      .catch(error => error);
    return request;
  },
  getAllCoinData: async () => {
    const url = 'https://api.coinranking.com/v1/public/coins?base=GBP';

    const request = await axios.get(url)
      .then(response => response.data)
      .catch(error => error);
    return request;
  },
  searchCoin: async (text) => {
    const url = `https://api.coinranking.com/v1/public/coins?prefix=${text}`;

    const request = await axios.get(url)
      .then(response => response.data)
      .catch(error => error);
    return request;
  },
  addPurchase: (coin) => {
    // add key property to coin object
    const newCoin = Object.assign({}, coin);
    newCoin.key = `${Math.round((new Date()).getTime() / 1000)}${Math.random().toString(36).substr(2, 9)}`;

    const data = Service.getStorage();

    if (!data.purchases) data.purchases = [];

    data.purchases.push(newCoin);

    Service.setStorage(data);
  },
  getPurchase: () => {
    const data = Service.getStorage();

    if (data && data.purchases && data.purchases.length > 0) {
      return data.purchases.map((elem) => {
        const updatedObject = Object.assign({}, elem);
        updatedObject.amount = parseFloat(elem.amount);
        updatedObject.purchasePrice = parseFloat(elem.purchasePrice);
        return updatedObject;
      });
    }

    return [];
  },
  updatePurchase: (purchase) => {
    const data = Object.assign({}, Service.getStorage());

    if (data && data.purchases && data.purchases.length > 0) {
      for (let i = 0; i < data.purchases.length; i += 1) {
        if (purchase.key === data.purchases[i].key) {
          data.purchases[i] = purchase;
          Service.setStorage(data);
          return true;
        }
      }
    }

    return false;
  },
  getPurchaseByKey: (key) => {
    const data = Service.getStorage();

    if (data && data.purchases && data.purchases.length > 0) {
      for (let i = 0; i < data.purchases.length; i += 1) {
        const purchase = data.purchases[i];
        if (purchase.key === key) return purchase;
      }
    }

    return false;
  },
  removePurchase: (key) => {
    const data = Service.getStorage();
    data.purchases = data.purchases.filter(elem => elem.key !== key);

    Service.setStorage(data);
  },
  getStorage: () => (JSON.parse(localStorage.getItem('wallet')) || {}),
  setStorage: (data) => {
    // data = { settings: {}, purchases: [] }
    localStorage.setItem('wallet', JSON.stringify(data));
  },
  removeStorage: () => {
    localStorage.removeItem('wallet');
  },
};

export default Service;



// WEBPACK FOOTER //
// ./src/service/index.js